import { useEffect, useState } from 'react';
/**
 * Uses mathMedia browser API
 * @param query media query
 */
export const useMedia = (query: string, defaultState = false) => {
  if (typeof window === 'undefined') {
    return defaultState;
  }

  const [state, setState] = useState(defaultState);

  useEffect(() => {
    let mounted = true;
    const mediaQueryList = window.matchMedia(query);

    const onChange = () => {
      if (!mounted) {
        return;
      }

      setState(Boolean(mediaQueryList.matches));
    };

    mediaQueryList.addEventListener('change', onChange);
    setState(mediaQueryList.matches);

    return () => {
      mounted = false;
      mediaQueryList.removeEventListener('change', onChange);
    };
  }, []);

  return state;
};
